module.exports = __webpack_public_path__ + "static/img/3.75d1aa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/3.png
// module id = XKYV
// module chunks = 0